import { Banner, BannerThemes, IconTrophy } from '@by-miles/bymiles-styles'

interface PromoBannerProps {
  firstName: string
  amount: number
  type: string
}

export const PromoBanner = ({ firstName, amount, type }: PromoBannerProps) => (
  <Banner
    icon={<IconTrophy />}
    theme={BannerThemes.mintTint}
    message={
      type === 'referAFriend' ? (
        <p className="LoNotSensitive">
          When you purchase a policy, your friend <strong className="LoSensitive">{firstName}</strong> will receive
          <strong className="LoSensitive"> £{amount} of free miles credit </strong> to their account, ready to use
          straight away.
        </p>
      ) : (
        <p className="LoNotSensitive">
          <strong>Credit added!</strong> You’ll have{' '}
          <strong className="LoSensitive">£{amount} of free miles credit</strong> in your account, ready to use straight
          away.
        </p>
      )
    }
  />
)
